import { CATEGORY_GAME } from "contants/game-type";
import { LIST_LINK, LIST_PROFILE } from "contants/menu-mobile";
import { URL_DOWNLOAD } from "contants/url-download";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { Dispatch, SetStateAction, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { selectCategoryGameList } from "store/game";
import { getGameList } from "store/game/game.thunk";
import {
  CategoryGameListType,
  CategoryGameType,
  GameListResponseType,
} from "types/game";

import StyledMenuMobileWrap from "./index.style";

interface nameList {
  name: string;
  setOpenShowMenuMobileButton: Dispatch<SetStateAction<boolean>>;
}

const MenuMobileWrap = (props: nameList) => {
  const { categoryId } = useParams();
  const { pathname: pathCategory } = useLocation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const categoryGameList = useAppSelector(selectCategoryGameList);

  useEffect(() => {
    if (!categoryId) return;

    if (pathCategory.includes(categoryId) && categoryGameList.length > 0)
      return;

    const findCategoryGame = CATEGORY_GAME.find((category: CategoryGameType) =>
      category.path.includes(`/${categoryId}`)
    );

    if (!findCategoryGame) return;

    dispatch(getGameList(findCategoryGame.id));
  }, [categoryId, pathCategory, categoryGameList.length]);

  const handleAction = async (categoryGame: CategoryGameType) => {
    const res = await dispatch(getGameList(categoryGame.id));

    const dataRes = res.payload as GameListResponseType;
    const { data: listGame } = dataRes;

    if (!listGame.length) return;
    const findGame = listGame.find(
      (game: CategoryGameListType) => game.provider_name
    );

    if (!findGame) return;
    navigate(`${categoryGame.path}/${findGame.provider_code}`);
  };

  const handleOnclick = (key: number) => {
    if (key === 8) {
      const apkFileName = URL_DOWNLOAD.split("/").pop();

      const downloadLink = document.createElement("a");
      downloadLink.href = URL_DOWNLOAD;
      downloadLink.download = apkFileName || "";

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
      return;
    }
  };
  const { name, setOpenShowMenuMobileButton } = props;
  return (
    <StyledMenuMobileWrap>
      <div className="list">
        <div className="list-menu">
          {name === "game" &&
            CATEGORY_GAME.map((categoryGame: CategoryGameType) => (
              <div
                className="list-menu-item"
                key={categoryGame.id}
                onClick={() => {
                  setOpenShowMenuMobileButton(false);
                  handleAction(categoryGame);
                }}
              >
                <Link className="link" to={"/"}>
                  <div className="icon">
                    {typeof categoryGame.icon == "string" ? (
                      <img src={categoryGame.icon} alt="" />
                    ) : (
                      <>{categoryGame.icon}</>
                    )}
                  </div>
                  <span className="text">{categoryGame.name}</span>
                </Link>
              </div>
            ))}
          {name === "profile" &&
            LIST_PROFILE.map((e, i) => (
              <div
                className="list-menu-item"
                key={i}
                onClick={() => setOpenShowMenuMobileButton(false)}
              >
                <Link className="link" to={e.link}>
                  <i className="icon">
                    <e.icon />
                  </i>
                  <span className="text">{e.name}</span>
                </Link>
              </div>
            ))}
          {name === "link" &&
            LIST_LINK.map((e, i) => (
              <div
                className="list-menu-item"
                key={i}
                onClick={() => setOpenShowMenuMobileButton(false)}
              >
                <Link
                  onClick={() => handleOnclick(e.key)}
                  className="link"
                  to={e.link}
                >
                  <i className="icon">
                    <e.icon />
                  </i>
                  <span className="text">{e.name}</span>
                </Link>
              </div>
            ))}
        </div>
      </div>
    </StyledMenuMobileWrap>
  );
};

export default MenuMobileWrap;
